export function createSelection({
  tableDataLength,
  defaultSelectedRowKeys = [],
  reserveSelection,
  selection = []
}) {
  return {
    isAllSelected: tableDataLength > 0 && defaultSelectedRowKeys.length === tableDataLength,
    selectOnIndeterminate: !!defaultSelectedRowKeys.length && defaultSelectedRowKeys.length !== tableDataLength,
    selection: reserveSelection ? new Set([...selection, ...defaultSelectedRowKeys]) : new Set([...defaultSelectedRowKeys]),
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/selection.js